// extracted by mini-css-extract-plugin
export default {"container":"RbcwwiJB0BfOqbos5HcO","content":"YQlAa0eI8ahduPklwGJD","title":"cpl6C4AGu7cHqGPYFumh","text":"fekBqBYoaHE1ct5Q30_8","improveText":"zZTlSu0JUDabNpHXLibL"};